import styled from "styled-components";
import { loadingIcon } from "../../../constants/joshConstants";
import { clearFix, LHS, MenuLink, RHS } from "./Element";
import { Image_Domain } from "../../../constants/joshConstants";

const LeftSIdeMenu = styled.section`
    position:fixed;right:16px;bottom:65px;
    ul{display:block;font-size:0;text-align:center;width:48px;
        li{display:block;margin-bottom:14px;width:100%;
            .profleImg{
            width:48px;height:48px;border-radius:99%;border:1px solid #fff;margin:auto;position:relative;
                img{width:100%;height:100%;overflow:hidden;border-radius:99%;object-fit:cover;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
            }
           a{
               display:block;text-align:center;
               span{margin:auto auto 3px auto;display:block;background-position:center}
                strong{font-size:12px;font-weight:400;color:#fff;display:block}
           }

        }li:last-child{margin-bottom:0}
        li.anim{
            position:relative;width:44px;height:44px;margin:22px auto auto;
            .animatBox{
                .musicIcon{width:44px;height:44px;border-radius:99%;position:relative;background: linear-gradient(140.21deg, #181818 21.26%, #353434 46.42%, #333333 48.32%, #1F1E1D 74.41%), radial-gradient(50.51% 50.7% at 50% 50%, #232323 0%, #202020 99.5%, #E9E9E9 100%);transform:rotate(-90deg);
                    img{width:24px;height:24px;position:absolute;left:calc(50% - 12px);top:calc(50% - 12px);border-radius:99%;background-image:url(${loadingIcon});background-color:#eaeaea;background-position:center;background-repeat:no-repeat;background-size:50% auto;}
                }
            }
            .anitmation {-webkit-animation:spin 3s linear infinite;-moz-animation:spin 3s linear infinite;animation:spin 3s linear infinite;position:fixed;}
            @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
            @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
            @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

            .melody{
                /* position:absolute; */
                transform: rotate3d(0, 5, -4, 45deg);position:absolute;left:-20px;bottom:0px;

                .commonCode{width:20px;height:20px;display:inline-block;position:relative;background-repeat:no-repeat;animation-fill-mode:forwards;animation-name:melodyAnimation;animation-iteration-count:infinite;animation-timing-function:linear;opacity:0;animation-direction:reverse;bottom:0}

                .melody-1{background-image:url("${Image_Domain}/static/images/josh/icon-melody2.svg");}
                .melody-2{background-image:url("${Image_Domain}/static/images/josh/icon-melody1.svg");left:-10px}
                .one {-webkit-animation: melodyAnimation 4s infinite 0s;animation: melodyAnimation 4s infinite 0s;}
                .two {-webkit-animation: melodyAnimation 4s infinite 2s;animation: melodyAnimation 4s infinite 2s;}
                @keyframes melodyAnimation {
                    0%   {bottom:10px;opacity:1;}
                    100% {bottom:40px;opacity:0;}
                    }
            }
        }
    }

    @media screen and (max-device-width:320px) and (-webkit-min-device-pixel-ratio: 2) {
      ul{width:30px !important;
        li{margin-bottom:8px !important;
          .profleImg{width:30px !important;height:30px !important;}
          .med320wd38{width:30px !important;height:30px !important;background-size:30px auto !important;}
          .med320wd30{width:30px !important;height:30px !important;background-size:16px auto !important;}
          &.anim{width:30px !important;height:30px !important;
            .animatBox{
              .musicIcon{width:30px !important;height:30px !important;}
            }
          }
          &.med320mb16{margin-bottom:16px !important;
            span{width:14px !important;height:14px !important;background-size:14px auto !important;left:calc(50% - 7px) !important;}
          }
        }
      }

   }
`;

const BottomBar = styled.section`
  position:fixed;bottom:0px;width:100%;z-index:99;background-image:linear-gradient(to top,#000,rgba(0,0,0,.6),transparent);
    ul{
      display:table;font-size:0px;width:100%;
      li{
        display:table-cell;vertical-align:middle;
        a{
          display:block;padding:13px;
          span{display:inherit;margin:auto;background-position:center;width:26px;height:22px;background-size:auto 22px; }
        }
      }
    }
  &&.white{background-color:#fff;}
`;

const ProfileDetails = styled.section`
    position:absolute;width:calc(100% - 80px);left:0px;bottom:50px;padding:0 14px 16px;
    .handler{display:block;
      span{color:#fff;}
    }
    .richText{
      font-size:12px;color:#fff;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow: hidden;
      strong{display:inline-block;font-weight:600;color:#fff;
        a{display:inline-block;font-weight:600;color:#fff;}
      }
      a{display:inline-block;}
    }
    .audioTitle{
      span{color:#fff;}
    }
`;

const LoginContainer = styled.section`
    position:fixed;top:0px;left:0px;z-index:99999999;width:100%;
`;

const LoginHeader = styled.header`
  box-shadow:inset 0px -1px 0px #202020;
    .PR{
      position:relative;padding:9px 0;
      .logo{width:66px;height:30px;margin:auto;display:block;
        img{width:100%;height:auto;}
      }
      .skipBtn{color:#BDBDBD;font-size:14px;padding:14px 14px;display:inline-block;position:absolute;right:0px;top:0px;}
      .backBtn{position:absolute;left:0px;top:0px;background-repeat:no-repeat;background-image:url(${Image_Domain}/static/images/josh_2/inc_backBtn.svg);background-size:12px;width:36px;height:100%;background-position:center}
    }
`;

const LoginContent = styled.section`
    .TAC{
      text-align:center;padding:28px 28px 36px;
      h4{font-size:24px;font-weight:500;margin-bottom:10px;color:#fff;}
      p{color:#757575;font-size:15px;line-height:18px;}
    }
    .LoginBtn{
      padding:0 14px;
      ul{
        li{
         margin-bottom:14px;
          a{border:1px solid #424242;box-sizing:border-box;border-radius:2px;padding:12px;
            span{color:#fff;font-size:12px;font-weight:600;line-height:22px;padding:0 0 0 32px}
          }
          a.active{border:1px solid #202020;background-color:#202020}
        }li:last-child{margin-bottom:0px;}
      }
    }


`;

const LegalText = styled.section`
    text-align:${props => props.textAlign};
    position:fixed;width:100%;text-align:center;bottom:0;left:0;padding:20px 14px;
    p{color:#FFFFFF;font-size:10px;
      a{display:inline-block;color:#65D1E8}
    }
`;

const OptContent = styled.section`
    padding:0 14px;
    h4{color:#fff;font-size:16px;font-weight:500;padding:32px 16px 34px;text-align:center;}
    .SendOtpBtn{padding:12px;background-color:#EA4E60;color:#fff;font-size:16px;font-weight:500;text-align:center;display:block;margin-top:20px;transition:0.5s}
    .SendOtpBtn.invalid{background:#424242;}
`;

const EnterNumber = styled.div`
    display:${props => props.display};
    .feild{border:1px solid #424242;box-sizing:border-box;border-radius:2px;
      ${LHS}{
        width:44px;
        label{width:100%;border-right:1px solid rgb(133 133 133 / 20%);padding:14px 3px;color:#fff;display:inline-block;text-align:center;font-size:14px;font-weight:600}
      }
      ${RHS}{
        width:calc(100% - 44px);padding:12px 12px;
        input{width:100%;background-color:transparent;display:inline-block;color:#fff;outline:none;font-size:14px;font-weight:600}
      }
      ${clearFix}
    }
`;

const EnterOtp = styled.div`
    text-align:center;
    ul{
      min-width:292px;width:292px;max-width:292px;margin:auto auto 10px;
      li{
        width:40px;height:46px;display:inline-block;border:1px solid #424242;border-radius:2px;padding:12px 2px;margin-right:10px;
        input{width:100%;background-color:#000;display:inline-block;color:#fff;outline:none;font-size:14px;font-weight:500;}
      }
      li:last-child{margin-right:0px;}
    }
    ul.invalid{
      li{border:1px solid #EA4E60}
    }
    p{font-size:10px;color:#E5436D}
    a.resentOtp{color:#BDBDBD;font-size:12px;display:inline-block;padding:0 20px 20px}

    // Custom styles
    .inputOtp{position:relative;margin:0 22px 20px;
      .inputBox{font-size:0px;position:relative;
          .libBox{display:inline-block;margin-right:8px;border:1px solid #BDBDBD;border-radius:2px;box-sizing:border-box;text-align:center;font-size:12px;width:calc((100% - 40px) / 6);
              input{display:inline-block;margin-right:8px;border:1px solid #BDBDBD;border-radius:2px;box-sizing:border-box;text-align:center;font-size:12px;padding:14px 0;width:100% !important;
                  &:last-child{margin-right:0px;}
              }
              &.otpError{
                  input{border: 1px solid #EA4E60;}
              }
          }
          input{display:inline-block;margin-right:8px;border:1px solid #BDBDBD;border-radius:2px;box-sizing:border-box;text-align:center;font-size:12px;padding:14px 0;width:calc((100% - 40px) / 6);
              &:last-child{margin-right:0px;}
          }
          &.otpError{
              input{border: 1px solid #EA4E60;}
          }
      }
    }
`;

const LangComp = styled.section`
    .logo{width:100px;height:auto;padding:10px 16px 0;margin:auto auto 87px;box-sizing:content-box;
      img{width:100px;height:auto;}
    }
    h4{font-size:18px;font-weight:600;color:#fff;text-align:center;margin-bottom:30px}
`;

const SelectLang = styled.div`
    ul{
      min-width:292px;width:292px;max-width:292px;margin:auto;
      li{
        width:60px;height:60px;border-radius:10px;border:1px solid #FFFFFF;display:inline-block;margin:0 15px 15px 0px;padding:4px;vertical-align:top;text-align:center;
        span{display:block;width:50px;height:50px;margin:auto auto 4px;background-size:auto 100%;background-position:center;}
        em{font-size:11px;display:block;color:#fff;}
      }
      li.selectedLang{
        background-color:#EA4E60;border:1px solid #EA4E60
      }
      .MR0{margin-right:0px}
    }
`;

const LangScreen = styled.section`
    background-image:url(${props => props.bgImg});
    height:100%;background-size:cover;background-repeat:no-repeat;position:relative;
    .overlay{background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);position:absolute;bottom:0px;width:100%;height:70%}
    .zindex{z-index:99999;position:relative}
`;

const ProfileCont = styled.section`
  header{
  ${LHS}{}
  ${RHS}{
    .skipBtn{color:#BDBDBD;font-size:14px;padding:14px 14px;display:inline-block;}
  }
  ${clearFix}
  }

`;

const UserDetails = styled.div`
  padding:20px 14px;
    .progressBar{
      margin-bottom:20px;
      span{
        width:100px;height:4px;background-color:#424242;position:relative;display:inline-block;
        em{position:absolute;left:0;top:0;display:inline-block;background-color:#fff;height:4px}
      }
    }
    h3{font-size:24px;color:#fff;font-weight:500;margin-bottom:10px;}
    p{font-size:15px;color:#757575;margin-bottom:21px}
`

const AddPhoto = styled(MenuLink)`
  background:#2F3030;border-radius:4px;color:#fff !important;font-size:16px;padding:8px 14px;display:inline-block;
`

const ProfileAdded = styled.figure`
  img{width:80px;height:80px;border-radius:99%;overflow:hidden;object-fit:cover;margin-bottom:4px;}
  figcaption{font-size:12px;color:#fff}
`

const EnterUserName = styled.div`
  .feild{
    ${LHS}{
      width:24px;
      label{width:100%;color:#757575;display:inline-block;font-size:20px;font-weight:600}
    }
    ${RHS}{
      width:calc(100% - 24px);
      input{width:100%;background-color:#000;display:inline-block;color:#fff;outline:none;font-size:20px;font-weight:600}
    }
    ${clearFix}
    .username{font-size:20px;color:#fff}
    .details{font-size:16px;color:#fff}
    textarea{width:100%;min-height:66px;background-color:transparent;font-size:16px;color:#fff;outline:none;}
  }

`;

const GenderComp = styled.ul`
  display:block;
  li{display:inline-block;
    a{background-color:#2F3030;border-radius:4px;padding:8px 14px;color:#fff;font-size:18px;margin-right:10px;}
  }
  li:last-child{
    a{margin-right:0px;}
  }
  li.active{
    a{
      background-color:#EA4E60;
    }
  }
`;

const GenderComp_v1 = styled(GenderComp)`
  margin-bottom:8px;
  li{
    a{background-color:#fff;color:#BDBDBD;border:1px solid #BDBDBD;padding:5px;font-size:16px;}
  }
  li.active{
    a{
      background-color:#fff;color:#65D1E8;border:1px solid #65D1E8;
    }
  }
`;


const FeedComp = styled(GenderComp)`
  text-align:center;margin-bottom:44px;
  li{
    a{font-size:14px;padding:6px 11px;margin-right:6px;margin-bottom:6px}
  }
`;

const FeedBtn = styled.a`
  min-width:266px;width:266px;max-width:266px;background:#FFFFFF;border-radius:4px;padding:7px;text-align:center;margin:auto;
  span{font-size:16px;font-weight:600;color:#202020}
`
const ThreeDost = styled.div`
  position:absolute;top:12px;right:0px;width:36px;height:36px;
  a{width:100%;height:100%;background-repeat:no-repeat;background-image:url(${Image_Domain}/static/images/josh_2/threedot.svg);background-size:3px 15px;background-position:center}
`
const BackbuttonDetail = styled(ThreeDost)`
  left:0;
  a{background-image:url(${Image_Domain}/static/images/josh_2/inc_backBtn.svg);background-size:8px auto;}
`;

const TopHeader = styled.header`
  position:fixed;top:0;left:0px;width:100%;z-index:999;
  .PR{position:relative;
    ul{
      display:block;font-size:0;text-align:center;
      li{
        display:inline-block;padding-top:10px;
        a{
          padding:10px 0 10px;
          span{font-size:13px;color:#EEEEEE;text-shadow:0px 1px 4px rgba(66, 66, 66, 0.4);display:inline-block;padding:0 10px}
          .bdr{background-repeat:no-repeat;background-image:url(${Image_Domain}/static/images/josh_2/divider.svg);background-size:1px 12px;}
          .bdrLeft{background-position:left center;}
          .bdrRight{background-position:right center;}
        }
      }
      a.nearby{
        span{font-weight:bold;padding-left:6px;}
        em{background-repeat:no-repeat;background-image:url(${Image_Domain}/static/images/josh_2/inc_nearby.svg);background-size:12px 12px;width:12px;height:12px;display:inline-block;position:relative;top:2px}
      }
      a.following{
        span{font-weight:bold}
      }
      a.follow{
        span{font-weight:bold}
      }
    }
  }
  &.darkBackBtn{height:48px;box-shadow:inset 0px -1px 0px #EEEEEE;background-color:#fff;
    ${ThreeDost}{top:6px;
      a{background-image:url(${Image_Domain}/static/images/josh_2/threedot_dark.svg);background-size:100%;}
    }
    ${BackbuttonDetail}{top:6px;
      a{background-image:url(${Image_Domain}/static/images/josh_2/icn_backBtn.svg);background-size:16px;background-position:14px center;}
    }
  }
`

const ProfileHeader = styled.header`
position:fixed;top:0;left:0px;width:100%;box-shadow:inset 0px -1px 0px #EEEEEE;background-color:#fff;z-index:999999999;
.PR{position:relative;padding:6px;
  ${LHS}{}
  ${RHS}{}
  ${clearFix}
  .table{display:table;width:100%;
    .tc{display:table-cell;vertical-align:middle;text-align:center;
      a.saveBtn, a.profile{min-width:36px;width:auto;color:#000;font-size:12px;color:#757575}
      a.profile{font-weight:600;color:#424242}
    }
  }

}
`;

const ProfileHeaderIcnCommon = styled.ul`
  font-size:0px;display:${props => props.display};
  li{
    display:inline-block;
    a{width:36px;height:36px;background-repeat:no-repeat;background-size:24px 24px;background-position:center;display:block;}
    a.icn_more{background-image:url(${Image_Domain}/static/images/josh_2/icn_more.svg);}
    a.icn_help{background-image:url(${Image_Domain}/static/images/josh_2/icn_help.svg)}
    a.icn_settings{background-image:url(${Image_Domain}/static/images/josh_2/icn_settings.svg)}
    a.icn_add_contacts{background-image:url(${Image_Domain}/static/images/josh_2/icn_add_contacts.svg)}
    a.icn_backBtn{background-image:url(${Image_Domain}/static/images/josh_2/icn_backBtn.svg)}

  }
`;

const UserProfileDetails = styled.section`
  padding:16px 14px 0;margin-top:50px;position:relative;
`;

const UserDetailsWrp = styled.div`
  display:table;width:100%;margin-bottom:13px;
  .TC{display:table-cell;vertical-align:top;
    picture{width:75px;height:75px;border-radius:99%;overflow:hidden;display:block;background:url('${Image_Domain}/static/images/josh_2/defaultprofile.svg') no-repeat;background-size: 100%;
      img{width:100%;height:100%;object-fit:cover;}
    }
    h3{font-size:16px;color:#000000;margin-bottom:4px;font-weight:bold;display:inline-block;display:-webkit-inline-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}
    h3.varified{background-image:url(${Image_Domain}/static/images/josh_2/verified.svg);background-repeat:no-repeat;background-size:12px 12px;background-position:right center;padding-right:18px}
    p{font-size:12px;color:#757575;margin-bottom:13px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;word-break:break-all;}
    ul{display:block;font-size:0px;text-align:center;
      li{display:inline-block;width:33.33%;
        span{font-size:14px;color:#000;display:block;margin-bottom:2px;font-weight:600}
        em{font-size:12px;color:#757575;display:block;margin-bottom:2px}
      }
    }
  }
  .wid75{width:75px}
  .PL10{padding-left:10px;}
`

const PopUp = styled.section`
  position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0, 0, 0, 0.48);z-index:9999;
    .border{background:linear-gradient(90deg, rgb(114, 211, 232) 0%, rgb(229, 84, 122) 100%);position:absolute;width:242px;height:306px;border-radius:10px;left:calc(50% - 121px);top:calc(50% - 153px);overflow:hidden;
      .content{background:#ffffff;width:234px;height:298px;border-radius:10px;margin:4px;text-align:center;padding:48px 13px 0 13px;
        .icon{margin:0 auto 40px;background:no-repeat left center / 101px auto;}
        .icon.youtube{background-image:url(${Image_Domain}/static/images/josh_2/icn_youtube.svg);width:101px;height:80px;}
        .icon.instagram{background-image:url(${Image_Domain}/static/images/josh_2/icn_instagram.svg);background-size:80px auto;width:80px;height:80px;}
        ul{
          li{margin-bottom:10px;
            a{padding:10px;font-size:14px;border-radius:2px;color:#000000;
              &.active{background:#EA4E60;color:#FFFFFF;font-weight:bold;}
            }
            &:last-child{margin-bottom:0;}
          }
        }
        &.contentText{padding-top:23px;
          .icon{margin-bottom:8px;}
          p{color:#000000;font-size:14px;line-height:19px;margin-bottom:24px;font-weight:bold;}
        }
      }

    }
`;
const ConfiguredBtn = styled.ul`
  display:table;font-size:0px;width:100%;margin-bottom:10px;
  li{display:table-cell;vertical-align:middle;
    a{
      display:block;padding:8px 12px;border:1px solid #EEEEEE;border-radius:2px;margin-right:10px;text-align:center;position:relative;
      span{display:inherit;margin:auto;background-position:center;width:16px;height:16px;background-size:auto 16px;}
      em{color:#757575;font-size:13px;font-weight:bold}
    }
    a.yt{padding:9px 8px}
    .P8{padding:9px 11px}
    .add{
      strong{background-position:center;width:12px;height:12px;background-size:auto 12;background-image:url(${Image_Domain}/static/images/josh_2/icb_addsocial.svg);background-repeat:no-repeat;position:absolute;right:-5px;bottom:-5px}
    }

  }.wid40{width:40px}
  .follow{
    a{background:#EA4E60;
      transition:background-color 1s linear;
      em{color:#fff}
    }
  }
  .Following{
    a{background:#EEEEEE;
      transition:background-color 1s linear;
      em{color:#757575}
    }
  }
  li:last-child a{margin-right:0;}
`;

const UserBio = styled.div`
  position:relative;margin-bottom:10px;
  .textContent{
    font-size:12px;color:#000;overflow:hidden;word-break:break-all;
    strong{font-weight:bold;}
  }
  .shadow{background-image:linear-gradient(to bottom,rgba(255,255,255,0.5),rgba(255,255,255,1));width:100%;height:40%;position:absolute;bottom:0px;left:0px;display:block;text-align:center;font-size:12px}

`;

const TabMenu = styled.ul`
display:table;font-size:0px;width:100%;margin-bottom:10px;
  li{display:table-cell;vertical-align:middle;text-align:center;padding:13px;box-shadow:inset 0px -2px 0px transparent;
    span{display:inline-block;margin:auto;background-position:center;width:20px;height:20px;}
  }.active{box-shadow:inset 0px -2px 0px #E94E60;}
`;

const ErrorComp = styled.section`
text-align:center;margin-top:40px;padding:0 20px;
  picture{display:inline-block;width:77px;height:auto;margin-bottom:12px;
    img{width:100%;height:auto;}
  }
  h2{font-size:12px;font-weight:600;margin-bottom:12px}
  .fnS14{font-size:14px}
  .fnS16{font-size:14px}
  p{color:#757575;font-size:12px;font-weight:400;margin-bottom:12px}
  a.btn{background:#EA4E60;border-radius:2px;padding:10px 30px;color:#fff;font-size:12px;font-weight:600;display:inline-block;}
  a.btn.MT36{margin-top:36px;}
  a.btn.MT16{margin-top:16px;}
  a.learnmore{padding:0 16px;color:#65D1E8}
	&&.homeFeed{position:absolute;top:calc(50% - 75px);margin:auto;left:calc(50% - 85px);
    h2{color:#fff}
  }
  &&.dark{position:absolute;top:calc(50% - 106px);margin:auto;left:calc(50% - 155px);
    h2,p{color:#fff}
  }

`
const ProfileBlockedComp = styled.div`
position:absolute;margin:auto;top:0;left:0;right:0;bottom:0;height:96px;width:238px;text-align:center;
  h2{font-size:16px;font-weight:600;color:#000000;margin-bottom:10px;}
  p{font-size:14px;color:#757575;margin-bottom:10px;}
  a{font-size:12px;color:#65D1E8;text-decoration:underline;}
`
const GridWrp = styled.ul`
grid-template-columns:${props => props.columns};display:grid;grid-gap:1px;
  li{background-color:#000;display:grid;align-content:center;position:relative;
    figure{
      img{width:100%;height:auto}
      span{word-break:break-all}
      .overlay{background: linear-gradient(180.18deg, rgba(0, 0, 0, 0) 0.15%, rgba(0, 0, 0, 0.6) 99.85%);position:absolute;width:100%;height:50%;top:50%;}
      .view{background-position:left center;padding:0 0 0 24px;position:absolute;left:14px;bottom:14px; font-size:12px;display:inline-block;color:#fff;background-size:18px 12px}
      .bagde{position:absolute;top:6px;right:12px;background:rgba(255, 255, 255, 0.74);border-radius:2px;color:#000;font-size:10px;padding:2px 4px;}
      .heart{background-position:left center;padding:0 0 0 20px;position:absolute;left:12px;bottom:12px; font-size:12px;display:inline-block;color:#fff;background-size:14px 12px}
    }
  }


`;


const LoginPopUp = styled.section`
  &&.LoginPop{
    position:fixed;top:0;left:0;background-color:rgba(0, 0, 0, 0.48);width:100%;z-index:999999;backdrop-filter:blur(2px);
    .loginPopContent{display:block;height:80%;position:relative;top:calc(50% - 40%);background-color:rgb(0 0 0 / 80%);width:90%;margin:auto}
    .loginPopContent.whiteBg{background-color:#fff;border-radius:12px;}
    .scroll{overflow:auto;padding-bottom:20px}
    .noBg{height:100%;width:100%;top:0;}
    ${EnterOtp}{
      .SendOtpBtn{margin-top:20px}
    }
    ${LegalText}{
      position:absolute;bottom:0px;
    }
  }
  &&.loginPopUpType1{
    top:0;bottom:0;position:fixed;overflow-y:scroll;overflow-x:hidden;
    .loginPopContent{height:auto;}
    ${LoginContent}{
      margin-top:60px;top:0px;margin-bottom:80px;
    }
    ${LegalText}{
      position:relative;padding-bottom:60px;
    }
  }
`;

const DownloadAppWrp = styled.section`
  position:fixed;top:0;left:0;z-index:999999;background:rgba(0,0,0,0.8);width:100%;height:100%;
  .alertBox{
      width:276px;background:linear-gradient(90.33deg, #72D3E8 2.63%, #E55379 99.73%);left:calc(50% - 138px);top:calc(50% - 65px);position:absolute;border-radius:10px;padding:4px;
      .textContent{
          width:100%;height:100%;background-color:#fff;border-radius:inherit;padding:30px;position:relative;
          p{color:000;font-size:11px;line-height:17px;font-weight:400;text-align:center;margin-bottom:12px}
          .plyStore{width:130px;height:40px;margin:auto;
              img{width:100%;height:auto}
          }
          .closeBtn{position:absolute;right:0px;top:0px;width:36px;height:36px;display:block;background-image:url("${Image_Domain}/static/images/josh/pop-close.svg");background-size:8px 8px;background-position:center center;background-repeat:no-repeat;cursor:pointer;}
      }
  }
`;

// left:calc(50% - 138px);top:calc(50% - 65px);
const MenuPopUpWrp = styled.section`
    position:absolute;top:0;left:0;z-index:99999999;background:rgba(0,0,0,0.8);width:100%;height:100%;display:table;
    .tc{display:table-cell;vertical-align:middle;
      .alertBox{
        /* width:276px;background:linear-gradient(90.33deg, #72D3E8 2.63%, #E55379 99.73%);position:absolute;border-radius:10px;padding:4px;left:calc(50% - 138px);top:calc(50% - 25%); */
        width:276px;background:linear-gradient(90.33deg, #72D3E8 2.63%, #E55379 99.73%);border-radius:10px;padding:4px;margin:auto;
        .textContent{
            width:100%;height:100%;background-color:#fff;border-radius:inherit;padding:30px;position:relative;
            .optionList{
              li{color:#424242;font-size:16px;margin-bottom:36px;background-size:18px auto;background-position:left center;background-repeat:no-repeat;padding-left:48px}
              li.icn_edit{background-image:url("${Image_Domain}/static/images/josh_2/icn_edit.svg")}
              li.icn_report{background-image:url("${Image_Domain}/static/images/josh_2/icn_report.svg")}
              li.icn_download{background-image:url("${Image_Domain}/static/images/josh_2/icn_download.svg")}
              li.icn_public{background-image:url("${Image_Domain}/static/images/josh_2/icn_public.svg")}
              li.icn_delet{background-image:url("${Image_Domain}/static/images/josh_2/icn_delet.svg");color:#EA4E60}
              li.icn_share{background-image:url("${Image_Domain}/static/images/josh_2/icn_share.svg");background-size:24px;}
              li:last-child{margin-bottom:0}
              }
            }
            .closeBtn{position:absolute;right:0px;top:0px;width:36px;height:36px;display:block;background-image:url("${Image_Domain}/static/images/josh/pop-close.svg");background-size:8px 8px;background-position:center center;background-repeat:no-repeat;cursor:pointer;}
        }
      }

`;

const FollowingCarouselBg = styled.div`
  width:${props => props.width};
  height:${props => props.height}px;
  background-position:center center !important;background-repeat:no-repeat !important;background-size:cover !important;border-radius:10px;overflow:hidden;margin:auto;position:relative;
`;

const FollowingCarousel = styled.section`
    position:absolute;top:0px;left:0;width:100%;z-index:${props => props.zIndex};height:100%;top:50px;
    h4{color:#FFFFFF;font-weight:500;font-size:16px;margin:0 34px 18px 34px;text-align:center;line-height:19px;overflow:hidden;max-height:38px;}
    ${FollowingCarouselBg}{
      .content{text-align:center;position:absolute;bottom:20px;left:0px;width:100%;
        .profilePic{width:55px;height:59px;margin:0 auto 15px auto;position:relative;
          img{width:100%;height:100%;object-fit:cover;border-radius:99%;border:1px solid #EEEEEE;}
          span.verified{background-image:url("${Image_Domain}/static/images/josh_2/icn_verified.svg");background-position:center;background-repeat:no-repeat;background-size:100% auto;position:absolute;bottom:-15px;right:-5px;width:29px;height:30px;}
        }
        p.name, span{color:#EEEEEE;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        p.name{font-weight:600;font-size:14px;margin-bottom:4px;}
        span{font-size:10px;display:block;margin-bottom:10px;}
        ul{font-size:0;margin-bottom:9px;
          li{font-size:10px;color:#EEEEEE;display:inline-block;vertical-align:middle;}
          li.sep{margin:-5px 4px 0 4px;color:#C4C4C4;}
        }
      }
    }
`
const CommonBtn = styled.div`
  font-size:12px;min-width:120px;text-align:center;padding:6px;border-radius:2px;display:inline-block;font-weight:600;text-transform:capitalize;
`
const FollowBtn = styled(CommonBtn)`
  background-color:#EA4E60;color:#fff;
  transition:background-color 1s linear;
`
const FollowingBtn = styled(CommonBtn)`
  background-color:#EEEEEE;color:#424242;
  transition:background-color 1s linear;
`
const ErrorToastMsgComp = styled.section`
  position:fixed;left:0px;width:calc(100% - 60px);z-index:99999999;border-radius:5px;padding:4px;text-align:center;
  bottom:40px;animation-timing-function:linear;animation:topToBottom ease 800ms;-webkit-animation:topToBottom ease 800ms;
-moz-animation:topToBottom ease 800ms;-o-animation:topToBottom ease 800ms;-ms-animation:topToBottom ease 800ms;margin:0 30px;
  .msgBox{
    background-color:#000;border-radius:inherit;padding:10px;display:inline-block;margin:auto;
    p{color:#fff;font-size:12px;}
  }
  @keyframes topToBottom {
    0% {
      bottom:0;
    }
    100% {
      bottom:40px;
    }
  }

`

const SettingWerp = styled.section`
    display:block;padding:0 14px;
    ul{display:inherit;font-size:0px;
        li{display:inherit;border-bottom:1px solid #EEEEEE;
            a{
                padding:8px 0 13px 0;display:inherit;background-image:url("${Image_Domain}/static/images/josh_2/right_arrow.svg");background-repeat:no-repeat;background-size:16px 16px;background-position:right center;
                span{color:#000;font-size:14px;background-size:24px 24px;background-position:left center;padding:0 18px 0 40px;}
                em{font-size:12px;color:#757575;padding:6px 40px 0 40px;display:block;}
            }
            &.notification{background-image:url("${Image_Domain}/static/images/josh_2/icn_toggle_on.svg");background-repeat:no-repeat;background-size:39px 26px;background-position:right 6px;
            &.no{background-image:url("${Image_Domain}/static/images/josh_2/icn_toggle_off.svg");}
          }
        }
    }
`;

const IconTable = styled.div`
    display:table;
    margin:${props => props.margin};
    padding:${props => props.padding};
    cursor:${props => props.Cursor};
    .tr{display:table-cell;vertical-align:middle}
`;

const PopUpTab = styled.div`
box-shadow:inset 0px -1px 0px #EEEEEE;margin-bottom:16px;position:sticky;top:0;background-color:#fff;z-index:1;width:100%;
  ${LHS}{
    width:calc(100% - 36px);
    ul{
      text-align:center;
        li{display:inline-block;width:50%;
          a{color:#757575;font-size:14px;padding:10px 0;font-weight:600;
            &.active{color:#000000;border-bottom:2px solid #000000;}
            &.activeRedBottom{color:#000000;border-bottom:2px solid #EA4E60;}
          }
        }
    }
  }
  ${RHS}{
    width:36px;
    a{
      width:36px;height:36px;background-image:url("${Image_Domain}/static/images/josh_2/icn_popupclose.svg");background-repeat:no-repeat;background-size:12px auto;background-position:center;
    }
  }
  ${clearFix()}
`;

const PopUpTabV1 = styled.div`
box-shadow:inset 0px -1px 0px #EEEEEE;margin-bottom:16px;position:sticky;top:0;background-color:#fff;z-index:1;width:100%;
  ${LHS}{
    width:calc(100% - 36px);
    ul{
      text-align:center;
        li{display:inline-block;width:50%;
          a{color:#757575;font-size:14px;padding:10px 0;font-weight:600;
            &.active{color:#000000;border-bottom:2px solid #000000;}
            &.activeRedBottom{color:#000000;border-bottom:2px solid #EA4E60;}
          }
        }
    }
  }
  ${RHS}{
    width:36px;
    a{
      width:36px;height:36px;background-image:url("${Image_Domain}/static/images/josh_2/icn_popupclose.svg");background-repeat:no-repeat;background-size:12px auto;background-position:center;
    }
  }
  ${clearFix()}
`;

const PopUpTabV2 = styled.section`
  box-shadow:inset 0px -1px 0px #EEEEEE;margin-bottom:16px;position:sticky;top:0;background-color:#fff;z-index:1;width:100%;
  ul{white-space:nowrap;overflow-x:auto;
    li{display:inline-block;
      a{color:#757575;font-size:14px;padding:10px 20px;font-weight:600;
        &.active{color:#000000;border-bottom:2px solid #000000;}
        &.activeRedBottom{color:#000000;border-bottom:2px solid #EA4E60;}
      }
    }
  }
`;


const ProfileProgStatus = styled.div`
  background:#4CAFC3;padding:13px 8px;
  ${LHS}{font-weight:600;font-size:10px;color:#fff;width:calc(100% - 60px)}
  ${RHS}{font-weight:600;font-size:10px;color:#fff;background-image:url("${Image_Domain}/static/images/josh_2/update-arrow.svg");background-repeat:no-repeat;background-size:auto 10px;background-position:right center;padding-right:14px}
  ${clearFix()}
`
const ProfileCompleted = styled.div`
  background:#00AE8D;padding:11px 8px;
  p{font-weight:600;font-size:12px;color:#fff;background-image:url("${Image_Domain}/static/images/josh_2/party-popper.svg");background-repeat:no-repeat;background-size:contain;background-position:left center;padding-left:24px}
`;

const ErrorMsgRed = styled.div`
  font-weight:600;font-size:12px;color:#EA4E60;background-image:url("${Image_Domain}/static/images/josh_2/icn-alret.svg");background-repeat:no-repeat;background-size:12px auto;background-position:left center;padding-left:20px;margin:10px 0;
  padding:${props => props.padding};
  margin:${props => props.margin};
`;

const ProfilePicOption = styled.section`
padding-top:12px;
  figure{
    width:100px;height:100px;margin:auto auto 8px;
    img{width:100%;height:100%;background-image:url("${Image_Domain}/static/images/josh_2/icn_defult_profile.svg");background-repeat:no-repeat;background-size:100%;background-position:center}
  }
  p{color:#EA4E60;font-size:12px;text-align:center;}
`



const ProfileDetailsFiled = styled.section`
  padding:0 14px 16px;
  ${LHS}{
    a{width:24px;height:24px;display:block;background-position:center;background-repeat:no-repeat;background-size:16px auto;}
    a.icn_profile_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_profile_gery.svg");background-size:auto 18px;}
    a.icn_at_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_at_grey.svg")}
    a.icn_edit_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_edit_grey.svg")}
    a.icn_gender_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_gender.svg");background-size:auto 19px;height:34px}
    a.icn_calender_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_calender.svg");background-size:auto 17px;}
    a.icn_link_grey{background-image:url("${Image_Domain}/static/images/josh_2/icn_link.svg");background-size:18px auto;}
  }
  ${RHS}{
    width:calc(100% - 30px);border-bottom:1px solid #EEEEEE;padding-bottom:6px;position:relative;
    input{width:100%;color:#BDBDBD;font-size:16px;outline:none;}
    p{font-size:12px;color:#757575;line-height:16px;}
    textarea{width:calc(100% - 40px);color:#BDBDBD;font-size:16px;outline:none;resize:none;height:24px}
    .countLeft{position:absolute;top:0;right:0;color:#757575;font-size:12px;}
  }
  ${clearFix()}
`;

const LoadingPopUp = styled.div`
	background:rgba(0, 0, 0, 0.6);width:100%;height:100%;z-index:99999999999999;position:fixed;top:0;left:0;display:table;
  .loader{background-image:url("${Image_Domain}/static/images/josh_2/loader.gif");background-repeat:no-repeat;background-position:center;background-size:100px;display:table-cell;vertical-align:middle;}
`;

const TopNudge = styled.section`
  margin:12px 16px 20px;padding:12px;background:#162A48;border-radius:8px;position:relative;
  h2{color:#FFFFFF;font-weight:600;font-size:14px;line-height:19px;margin-bottom:2px;}
  p{color:#FFFFFF;font-weight:400;font-size:12px;line-height:16px;}
  .closeBtn{position:absolute;top:12px;right:12px;width:18px;height:18px;background-image:url("${Image_Domain}/static/images/josh_2/nudge_close.svg");background-repeat:no-repeat;background-position:center;background-size:18px;}
`;

export { AddPhoto, BackbuttonDetail, BottomBar, ConfiguredBtn, DownloadAppWrp, EnterNumber, EnterOtp, EnterUserName, ErrorComp, ErrorMsgRed, ErrorToastMsgComp, FeedBtn, FeedComp, FollowBtn, FollowingBtn, FollowingCarousel, FollowingCarouselBg, GenderComp, GenderComp_v1, GridWrp, IconTable, LangComp, LangScreen, LeftSIdeMenu, LegalText, LoadingPopUp, LoginContainer, LoginContent, LoginHeader, LoginPopUp, MenuPopUpWrp, OptContent, PopUp, PopUpTab, PopUpTabV1, PopUpTabV2, ProfileAdded, ProfileBlockedComp, ProfileCompleted, ProfileCont, ProfileDetails, ProfileDetailsFiled, ProfileHeader, ProfileHeaderIcnCommon, ProfilePicOption, ProfileProgStatus, SelectLang, SettingWerp, TabMenu, ThreeDost, TopHeader, TopNudge, UserBio, UserDetails, UserDetailsWrp, UserProfileDetails };

